import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
var DeviationDuperbrowseContext = function (_a) {
    var children = _a.children, deviations = _a.deviations, streamId = _a.streamId, parent = _a.parent;
    return (React.createElement(DuperbrowseStreamContextProvider, { stream: {
            items: deviations,
            streamId: streamId,
            parent: parent,
        } }, children));
};
DeviationDuperbrowseContext.displayName = 'DeviationDuperbrowseContext';
export default DeviationDuperbrowseContext;
//# sourceMappingURL=DeviationDuperbrowseContext.js.map